import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Link } from 'react-router-dom';

import Loading from '../../Components/Loading';

import { setWaitCampaign } from '../../_redux/actions/campaign';

import { ReactComponent as LogoYalo } from '../../img/logo-yalo.svg';

import icon1 from '../../img/icon-1.png';
import icon3 from '../../img/icon-3.png';

import farmacias2 from '../../img/drogaraia-drogasil.png';

import { ReactComponent as LogoDrConsulta } from '../../img/dr-consulta2.svg';
import DrogasilDrogaRaia from '../../img/drogasil--drogaraia.png';
import stores from '../../utils/stores';
import WhatsAppBtn from '../../Components/WhatsAppBtn';

import './index.scss';

import { campaignUtils } from '../../utils';

class HomeFidelidade extends Component {
	componentWillMount() {
		if (campaignUtils.checkExist(this.props.location.search)) {
			let campaignData = campaignUtils.getData();
			this.props.setWaitCampaign(campaignData);
		}
	}
	componentDidMount() {
		if (window.jQuery) {
			let $ = window.jQuery;

			$('.drc-carousel').slick({
				centerPadding: '30px',
				infinite: false,
				arrows: false,
				dots: true
			});
			$('.discounts-carousel').slick({
				centerPadding: '30px',
				infinite: false,
				arrows: false,
				dots: true,
				mobileFirst: true,
				responsive: [
					{
						breakpoint: 992,
						settings: 'unslick'
					}
				]
			});
		}
		sessionStorage.setItem('store', stores.fidelidade);
	}
	render() {
		return (
			<div className='page-wrapper'>
				<Loading></Loading>
				<div className='container-fluid'>
					<div className='row'>
						<div className='col-xs-12 col-md-12 landing'>
							<section className='section featured'>
								<div className='container-fluid'>
									<div className='row'>
										<div className='col-xs-12'>
											<a
												href='https://yalo.com.br'
												className='hidden-md hidden-lg logomobile'>
												<LogoYalo className='img-responsive'></LogoYalo>
											</a>
										</div>
									</div>
									<div className='row'>
										<div className='col-xs-12 col-md-7 center-mobile'>
											<h1 className='f-bold'>
												<br />A assinatura
												<br />
												da saúde!
											</h1>
											<h2>
												O programa de assinatura
												<br />
												do
												<span className='logo-drconsultawhite'>
													{' '}
													dr<span>.</span>consulta
												</span>
												, agora <br /> com consultas online.
											</h2>
										</div>
									</div>
									<div className='row'>
										<div className='spaceBox'>
											<div className='col-xs-12 col-md-4 space-box'>
												<div className='drc-box-new'>
													<div className='drc-box--content-new'>
														<h2 className='text-center'>
															<LogoDrConsulta
																alt='dr.consulta'
																className='svg-consulta'></LogoDrConsulta>
															<br />
															Consulta presenciais e online por apenas{' '}
															<strong className='f-black'>R$ 40</strong>
															<br />
															com retorno gratuito em até 30 dias
															<br /> e<strong className='f-black'>
																{' '}
																20%
															</strong>{' '}
															de desconto em exames.
														</h2>
													</div>
												</div>
											</div>
											<div className='col-xs-12 col-md-4 space-box'>
												<div className='drc-box-new'>
													<div className='drc-box--content-new'>
														<h2 className='text-center'>
															<img
																src={DrogasilDrogaRaia}
																className='imgbox'
																alt=''
															/>{' '}
															<br />
															<strong className='f-black'>60%</strong> de
															desconto em medicamentos <br />
															genéricos tarjados
															<br />e <strong className='f-black'>
																muito
															</strong>{' '}
															mais!
														</h2>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</section>
							<section className='section-diferenca'>
								<div className='container-fluid'>
									<div className='row'>
										<div className='col-md-12'>
											<h2 className='f-black' id='mais-saude'>
												Duas opções de assinaturas para você escolher
											</h2>
										</div>
									</div>
									<div className='row'>
										<div className='col-12 col-md-2 text-center'>
											<img src={icon1} className='img' alt='' />
										</div>
										<div className='col-12 col-md-10'>
											<h3 className='f-black'>YALO Fidelidade</h3>
											<p className='f-regular'>
												É a assinatura que te permite economizar nas consultas e
												exames médicos de rotina. Clientes YALO Fidelidade pagam{' '}
												<strong>R$40,00</strong>{' '}
												<span>em qualquer consulta</span> no dr.consulta,{' '}
												<span>presencial ou online</span> (exceto odontologia),
												com retorno gratuito em até 30 dias e, além disso, tem{' '}
												<strong>20%</strong> <span>de desconto nos exames</span>
												.
											</p>
										</div>
									</div>

									<div className='row'>
										<div className='col-12 col-md-2 text-center'>
											<img src={icon3} className='img' alt='' />
										</div>
										<div className='col-12 col-md-10'>
											<h3 className='f-black'>YALO Vida</h3>
											<p className='f-regular'>
												É a assinatura para quem se preocupa com as contas das
												farmácias. <span>A YALO</span> é o único programa de
												assinatura que te dá <strong>60%</strong> de desconto em
												medicamentos genéricos tarjados nas redes{' '}
												<span>Droga Raia</span> e <span>Drogasil</span>. Veja
												abaixo os demais descontos!
											</p>
										</div>
									</div>
								</div>
							</section>

							<section className='diferenca-new'>
								<div className='container-fluid'>
									<div className='row text-center'>
										<div className='col-12'>
											<h2 className='f-black'>
												Economize em mais de 2.000 farmácias
											</h2>
										</div>
									</div>
									<div className='row text-center'>
										<div className='col-12 col-sm-6 col-md-3'>
											<h3 className='desconto-economize-new'>60%</h3>
											<p className='text-economize-new'>
												de desconto em medicamentos genéricos tarjados
											</p>
										</div>
										<div className='col-12 col-sm-6 col-md-3'>
											<h3 className='desconto-economize-new'>35%</h3>
											<p className='text-economize-new'>
												de desconto em medicamentos genéricos isentos de
												prescrição
											</p>
										</div>
										<div className='col-12 col-sm-6 col-md-3'>
											<h3 className='desconto-economize-new'>
												<sup className='txt-ate'>Até</sup>25%
											</h3>
											<p className='text-economize-new'>
												de desconto em medicamentos
												<br />
												de marca
											</p>
										</div>
										<div className='col-12 col-sm-6 col-md-3'>
											<h3 className='desconto-economize-new'>5%</h3>
											<p className='text-economize-new'>
												de desconto no
												<br />
												setor de perfumaria
											</p>
										</div>
									</div>
									<div className='row text-center'>
										<div className='col-12'>
											<img src={farmacias2} className='img-new' alt='' />
										</div>
									</div>
								</div>
							</section>
							<footer className='footer'>
								{/*<div className="subfooter">
									<div className="container">
										<div className="row">
											<div className="col-12 text-center"><h2>Fale com a gente e conheça o <strong>yalo fidelidade</strong>, nosso produto mais econômico, por<br /> <sup className="sup-fidelidade">12x </sup>R$ 31,90.</h2></div>
										</div>
									</div>
								</div>
								<div className="subfooter-yalofarma">
									<div className="container">
										<div className="row">
											<div className="col-12 text-center">
												<a href="https://www.yalo.com.br/yalofarma">
													<h2>Experimente gratuitamente o yalo farma.</h2>
												</a>
											</div>
										</div>
									</div>
		</div>*/}
								{/*}
								<div className='container-fluid'>
									<div className='row footer-top'>
										<div className='col-12 col-md-6 col-lg-3'>
										<img
														src={logoYaloHorizontal}
														className='img'
														alt=''
													/>
											<p> <strong>CNPJ 28.757.895/0001-22</strong></p>
											<p className='f-light'> Copyright © 2020 - yalo</p>
											<p className='f-light'>	Todos os direitos reservados.  </p>
										</div>
										<div className='col-12 col-md-6 col-lg-3 link-contact'>
											<h3>&nbsp;</h3>
											<a href="tel:+4000-1664" className="icon-phone">Fale conosco: 4000-1664</a>
											<a href="https://api.whatsapp.com/send?phone=5511983120317" className="icon-whats">Vendas: (11) 98312-0317</a>
											<a href="https://api.whatsapp.com/send?phone=5511983120377" className="icon-whats">Atendimento: (11) 98312-0377</a>
											<a href="mailto:contato@yalo.com.br" ><i className="icon-mail"></i>contato@yalo.com.br</a>
										</div>
										<div className='col-12 col-md-6 col-lg-3'>
											<h3>&nbsp;</h3>
											<p>Horário de funcionamento:</p>
											<p>De segunda a sexta-feira, <br/>das 7h às 20h</p>
											<p>Exceto feriados</p>
										</div>
										<div className='col-12 col-md-6 col-lg-3'>
											<h3>&nbsp;</h3>
											<p>Siga a gente nas<br /> Redes Sociais</p>
											<ul className='icon-social'>
													<li><a href="https://www.facebook.com/yalobrasil" className='icon-facebook'>Facebook</a></li>
													<li><a href="https://www.instagram.com/yalobrasil/" className='icon-instagram'>Instagram</a></li>
													<li><a href="https://pt.linkedin.com/company/yalobrasil" className='icon-linkedin'>LinkedIn</a></li>
											</ul>
										</div>
									</div>
									<div className='row'>
										<div className='col-md-12'>
											<p className='juridic'> <small> OODONTOLOGIA: não incluso consultas, exames ou procedimentos. EXAMES: os descontos são aplicados apenas para exames realizados nos centros médicos próprios do dr.consulta. Não inclusos check-ups e pacotes. MICRO PROCEDIMENTOS E CIRURGIAS: Não estão inclusos</small></p>
											</div>
									</div>
									<div className='row'>
										<div className='col-xs-12'>
											<div className='utils'> <small>© 2020 yalo – Todos os direitos reservados |
												<a href='https://yalo.com.br/termos' target='_blank' rel='noopener noreferrer'>Termos e Condições do Site</a> |
												<a href='https://yalo.com.br/files/Politica_de_Privacidade_e_Seguranca_Yalo.951f98bf.pdf' target='_blank' rel='noopener noreferrer'>Política de Privacidade e Segurança</a> |
												<a href='https://yalo.com.br/contratos' target='_blank' rel='noopener noreferrer'>Contratos</a></small> </div>
										</div>
									</div>
								</div>*/}
								<div className='visible-md visible-lg last-message'></div>
							</footer>
						</div>
					</div>
				</div>
				<WhatsAppBtn
					phone='+5511983120317'
					message='Olá,+estou+entrando+em+contato+através+do+site+Yalo'
				/>
				<Link
					to='beneficiario'
					className='f-bold button-sticky hidden-lg mobile-sign'>
					Assinar agora!
				</Link>
			</div>
		);
	}
}

const mapStateToProps = actionObject => {
	return actionObject;
};

const mapDispatchToProps = dispatch =>
	bindActionCreators({ setWaitCampaign }, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(HomeFidelidade);
